export const VIEW = {
  DOT: 'dot',
  LINE: 'line',
}

export const SIZE = {
  S: 's',
  M: 'm',
}
